module.exports = __webpack_public_path__ + "img/monthly-logo.2393f423.png";